export const DataFields = (t) => {
    return [
      {
        name: "",
        fields: [
          {
            id: "name",
            name: t('builder_products_form_name'),
            type: "text",
            required: true,
            defaultValue: "",
            size: "small"
          },
          {
            id: "description",
            name: t('builder_products_form_description'),
            type: "text",
            required: true,
            defaultValue: "",
            size: "small"
          },
          {
            id: "price",
            name: t('builder_products_form_price'),
            type: "number",
            required: true,
            defaultValue: 0,
            inputProps: { min: 0, max: 100000 },
            endAdornment: { value: "$" },
            startAdornment: null,
            size: "small"
          },
          {
            id: "calories",
            name: t('builder_products_form_calories'),
            type: "number",
            required: false,
            defaultValue: 0,
            inputProps: { min: 0, max: 100000 },
            endAdornment: null,
            startAdornment: null,
            size: "small"
          },
          {
            id: "portions",
            name: t('builder_products_form_portions'),
            type: "number",
            required: false,
            defaultValue: 0,
            inputProps: { min: 0, max: 100 },
            endAdornment: null,
            startAdornment: null,
            size: "small"
          },
          {
            id: "preparation_time",
            name: t('builder_products_form_preparation_time'),
            type: "number",
            required: false,
            defaultValue: 0,
            inputProps: { min: 0, max: 100 },
            endAdornment: { value: "mins" },
            startAdornment: null,
            size: "small"
          },
          {
            id: "image",
            name: t('builder_products_form_image'),
            type: "image",
            required: false,
            isImage: true,
            defaultValue: "",
            size: "small"
          },
          {
            id: "showImage",
            name: t('builder_products_form_show_image'),
            type: "switch",
            required: true,
            defaultValue: false,
            size: "small"
          },
          {
            id: "active",
            name: t('builder_products_form_active'),
            type: "switch",
            required: true,
            defaultValue: false,
            size: "small"
          },
        ]
      }
    ]
  }